// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"81eb470e","724":"84ea6185"}[chunkId] + ".chunk.js";
};